import { apiFetcher } from '@/api/api'
import { useCacheSWR } from '@/api/swrCache'
import { useMemo } from 'react'

// 交易记录查询
export function useQueryDealRecord(filters: any) {
  const cacheKey: [string, Record<string, any>] = useMemo(() => ['useQueryDealRecord', filters], [filters])
  
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/fd/api/v1/transactions/queryDealRecord',
        type: 'post'
      },
      {
        arg: {...filters}
      }
    )
  }
  const result = useCacheSWR(cacheKey, fetcher, {dedupingInterval: 5 * 1000, author: true})

  const list = result.data?.data?.list ?? []
  const totalRecord = result.data?.data?.totalRecord ?? 0
  const totalPage =result.data?.data?.totalPage ?? Math.ceil(totalRecord / filters.pageSize)
  return{
    ...result,
    list,
    totalRecord,
    totalPage
  }
}